import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthClientService } from './auth-client.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [AuthClientService],
})
export class AuthClientModule {}
